/* eslint-disable react/no-danger */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { ReactElement, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { Button } from 'elmo-elements';

import { HelperType, FaqType } from '@/modules/types/helper';
import { ElearningPlayerStateType } from '@/components/Player/modules/reducers/elearningPlayer';

import Faq from './components/Faq';
import General from './components/General';
import SystemRequirement from './components/SystemRequirement';

export interface HelperViewPropsType {
  isVisible: boolean;
  content: undefined | HelperType[];
  faq: undefined | FaqType[];
  closeHelper: () => void;
}

const HelperView = ({
  isVisible,
  content,
  faq,
  closeHelper,
}: HelperViewPropsType): ReactElement => {
  const [helperState, setHelperState] = useState({
    isVisibleGeneral: true,
    isVisibleFaq: false,
    isVisibleSystemReq: false,
  });

  const elearningPlayerState: ElearningPlayerStateType = useSelector(
    (state: { elearningPlayer: ElearningPlayerStateType }) =>
      state.elearningPlayer,
  );

  useEffect(() => {
    if (!elearningPlayerState.isVisibleHelper) {
      setHelperState({
        isVisibleGeneral: true,
        isVisibleFaq: false,
        isVisibleSystemReq: false,
      });
    }
  }, [elearningPlayerState.isVisibleHelper]);

  const classNamePrefix = 'module-viewer-helper';

  let generalContent = '';
  let systemContent = '';
  content?.map((contentItem) => {
    if (contentItem.name === 'general') {
      generalContent = contentItem.content;
    }
    if (contentItem.name === 'system') {
      systemContent = contentItem.content;
    }
  });

  const handlerFaqBtn = () => {
    setHelperState({
      isVisibleGeneral: false,
      isVisibleFaq: true,
      isVisibleSystemReq: false,
    });
  };

  const handlerSystemReqBtn = () => {
    setHelperState({
      isVisibleGeneral: false,
      isVisibleFaq: false,
      isVisibleSystemReq: true,
    });
  };

  const handlerCloseBtn = () => {
    closeHelper();
  };

  return (
    <div
      className={`${classNamePrefix}__wrapper ${isVisible ? 'is-visible' : ''}`}
    >
      <Button
        id="HelperCloseBtn"
        className={`${classNamePrefix}__bg`}
        onClick={handlerCloseBtn}
      />
      <div className={`${classNamePrefix}__buttons`}>
        <Button
          type="primary"
          className="mx-2 px-5"
          onClick={handlerFaqBtn}
          id="HelperBtnFaq"
        >
          FAQ
        </Button>
        <Button
          type="primary"
          className="mx-2"
          onClick={handlerSystemReqBtn}
          id="HelperBtnSystemReq"
        >
          System REQ.
        </Button>
      </div>

      <Faq
        content={faq}
        isVisible={helperState.isVisibleFaq}
        classNamePrefix={classNamePrefix}
      />

      <SystemRequirement
        content={systemContent}
        isVisible={helperState.isVisibleSystemReq}
        classNamePrefix={classNamePrefix}
      />

      <General
        content={generalContent}
        isVisible={helperState.isVisibleGeneral}
        classNamePrefix={classNamePrefix}
      />
    </div>
  );
};

export default HelperView;
